import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { API_URL } from '../config';
import { LoginForm } from '../interfaces/login-form.interface';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  API_URL = API_URL;

  constructor(private http: HttpClient, ) { }

  loginUser(formData: LoginForm) {
    return this.http.post(`${this.API_URL}/ian/usuario/login`, formData)
          .pipe(
              tap( (resp: any) => {
                if (resp.datos.length) {
                  localStorage.setItem('token', resp.datos);
                }
                if (resp.datos === ''){
                  console.log(formData.usuario);
                  localStorage.setItem('token', formData.usuario)
                }
              })
          );
  }

  CambiarContraseña(password) {
    return this.http.post(`${this.API_URL}/ian/usuario/password`, password)
          .pipe(
              tap( (resp: any) => {
                if (resp.datos.length) {
                  localStorage.setItem('token', resp.datos);
                }
              })
          );
  }
}
